/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationRejectRequest extends models.ScheduleRecommendationActionBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationRejectRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationRejectRequest>): ScheduleRecommendationRejectRequest {
        let obj = Object.assign(new ScheduleRecommendationRejectRequest(), model);
        ScheduleRecommendationRejectRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationRejectRequest>): ScheduleRecommendationRejectRequest {
        if (!model) return null;
        return ScheduleRecommendationRejectRequest.newInstance(<ScheduleRecommendationRejectRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationRejectRequest) {
        if (!obj) return;

        models.ScheduleRecommendationRejectRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationRejectRequest): boolean {
        if (models.ScheduleRecommendationActionBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleRecommendationRejectRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account Id
     */
    service_account_id: string;

    /**
     * Reason for Rejection
     */
    reason: string;

}
